import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dispatchForecastDate',
  standalone: true
})
export class DispatchForecastDatePipe implements PipeTransform {
  transform(value: Date | string, locale: string): string {
    return new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: '2-digit',
      timeZone: 'UTC'
    }).format(new Date(value));
  }
}